import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import './carbonTheme.scss';
import reportWebVitals from './reportWebVitals';
import {useEntraAuthProvider} from './lib/entra-auth/entra-auth-provider';
import {initStorageCleanup} from './lib/storage-cleanup';
import App from './app';

// Initialize storage cleanup to remove stale download entries
initStorageCleanup();

const {EntraAuthProvider} = useEntraAuthProvider();

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

root.render(
    <React.StrictMode>
        <EntraAuthProvider>
            <App />
        </EntraAuthProvider>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
